import axios, { AxiosResponse } from 'axios';
import { WishListRequestModel, WishList, WishListProduct, WishListItem } from '@/models/WishList';
import { AssociatedUser } from '@/models/SignIn';

export default class WishListService {

    private profileId: string = (window as any).CbxApiContextKey;
    private endpoint: string;

    constructor(args: any = {}) {
        if (args.profileId)
            this.profileId = args.profileId;
        this.endpoint = `/contextapi/${this.profileId}/v1/wishlist`;
    }

    public async getWishLists(): Promise<WishListRequestModel> {
        try {
            const res: AxiosResponse<any> = await axios.get(`${this.endpoint}`);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async removeWishList(id: string): Promise<string> {
        try {
            await axios.delete(`${this.endpoint}/${id}`);
            return id;
        } catch (e) {
            console.log(e);
        }
    }

    public async addWishListItem(item: WishListItem): Promise<WishListProduct> {
        try {
            const res: AxiosResponse<any> = await axios.post(`${this.endpoint}`, item);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async updateWishList(payload: WishList): Promise<WishList> {
        try {
            const res: AxiosResponse<WishList> = await axios.post(`${this.endpoint}/updatelist`, payload);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async getAssociatedUsers(): Promise<AssociatedUser[]> {
        try {
            const res: AxiosResponse<AssociatedUser[]> = await axios.get(`${this.endpoint}/associated`);
            return res.data;
        } catch (e) {
            return [];
        }
    }

    public async setAssociatedUser(payload: string): Promise<boolean> {
        try {
            await axios.post(`${this.endpoint}/associated/${payload}`);
            return true;
        } catch (e) {
            return false;
        }
    }
}
